/* eslint-disable */
import React, {PropTypes} from 'react';
import ConfigD from './util/ConfigD';

const ImagemHost = (props) =>{
    var imagemHost = '';
    if(window.location.hostname === 'sac.sebrae.com.br'){
        imagemHost = <img src={ConfigD.getServerBase() + '/img/logo-sebrae2.png'} alt="Ouvidoria do sistema SEBRAE" />
    }else{
        imagemHost = <img src={ConfigD.getServerBase() + '/img/logo_Ouvidoria_grande.png'} alt="Ouvidoria do sistema SEBRAE"  />
    }

    return (
        <div>
            {imagemHost}
        </div>);

}
export default ImagemHost;



/** WEBPACK FOOTER **
 ** ./src/components/ImagemHost.js
 **/